import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-255" data-mp="1p4v7cp8lzity">
      <Reveal data-id="element-256" data-mp="1u4rbqpl7xca1">
        <SectionHeading id="tomos" eyebrow="Todo lo que recibís" title="6 Tomos completos" description="Una biblioteca espiritual para estudiar las Escrituras de una manera sencilla, organizada y práctica." data-id="element-257" data-mp="xce0q1825z9v" />
      </Reveal>

      <ol className="mt-8 grid gap-3 md:grid-cols-2 lg:grid-cols-3" data-id="element-258" data-mp="16brdb2rhb3yt">
        {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-6 text-center" data-id="element-259" data-mp="1ba2l77y7r4ee" data-mpi={i}>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-260" data-mp="2qo8hze54zig0">
              Tomo {i + 1}
            </span>
            <h3 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-261" data-mp="2mnoockjruwym">
              {tomo.title}
            </h3>
            <p className="mt-1 text-sm font-semibold text-accent" data-id="element-262" data-mp="2hpn6g2y313oq">
              {tomo.lead}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-263" data-mp="2cqtpu1ni0wkc">
              {tomo.desc}
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-264" data-mp="22ynxgqtc4d4m">
              {tomo.includes.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-surface-alt px-3 py-1.5 text-xs text-ink-muted" data-id="element-265" data-mp="1ywj9o8pkiapw">
                  <CheckIcon size={12} className="flex-shrink-0 text-accent" strokeWidth={3} data-id="element-266" data-mp="1oyll1k3sqbwr" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-auto pt-5 text-sm font-bold uppercase tracking-wide text-gold" data-id="element-267" data-mp="1aalb4zllfsqa">
              Valor {tomo.value}
            </p>
          </Reveal>)}
      </ol>

      <Reveal className="mt-6 rounded-2xl border border-line bg-surface-alt p-6 md:p-8" data-id="element-268" data-mp="11cja4k1v1030">
        <h3 className="font-display text-lg font-bold uppercase text-ink" data-id="element-269" data-mp="15cbgcq3s6u57">
          Cada tomo incluye
        </h3>
        <ul className="mx-auto mt-4 flex max-w-4xl flex-wrap justify-center gap-2" data-id="element-270" data-mp="1t3ywcczi8ksp">
          {tomoIncludes.map(item => <li key={item} className="flex items-center gap-2 rounded-full bg-surface px-4 py-2 text-sm text-ink-muted" data-id="element-271" data-mp="1y3v0cc87cc89">
              <CheckIcon size={13} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-272" data-mp="1oaw3y86grhe3" />
              <span data-id="element-273" data-mp="2gs8cozdy8gcg">{item}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}